/* Flash Promo storefront v2 — see theme/INTEGRATION.md in the flash-sales repo. */
(function (root) {
  'use strict';

  var MAX_CODES = 5; // Shopify applies at most five discount codes to a cart

  // Pure: cart lines that exceed the promo quota (shared per product) or the variant stock.
  function computeCaps(items, statuses) {
    var left = {};
    var fixes = [];
    items.forEach(function (item) {
      var pid = String(item.product_id);
      var s = statuses[pid];
      if (!s || s.state !== 'active' || s.remaining <= 0) return;
      if (!(pid in left)) left[pid] = s.remaining;
      var stock = s.variants ? s.variants[String(item.variant_id)] : null;
      var allowed = Math.max(0, Math.min(item.quantity, left[pid], stock == null ? Infinity : stock));
      left[pid] -= allowed;
      if (allowed < item.quantity) {
        fixes.push({ key: item.key, variantId: item.variant_id, requested: item.quantity, allowed: allowed });
      }
    });
    return fixes;
  }

  function isFlashCode(code) {
    return /^FLASH-[A-Z0-9]{10}$/i.test(String(code));
  }

  // Pure: the customer's own codes are kept, stale flash codes are replaced by the current ones.
  function mergeCodes(cartCodes, flashCodes) {
    var codes = cartCodes.filter(function (c) { return !isFlashCode(c); }).concat(flashCodes);
    return { codes: codes, overflow: codes.length > MAX_CODES };
  }

  function promoPriceCents(cents, percent) {
    return Math.round(cents * (100 - percent) / 100);
  }

  function formatMoney(cents, format) {
    function amount(decimals, thousands, decimal) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return String(format || '{{amount}}').replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return amount(0, ',', '.');
        case 'amount_with_comma_separator': return amount(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return amount(0, '.', ',');
        case 'amount_with_apostrophe_separator': return amount(2, "'", '.');
        default: return amount(2, ',', '.');
      }
    });
  }

  // Pure: what a block shows. An unreachable app hides everything: never show a discount the cart cannot apply.
  function displayState(status, showMissed, now, appDown) {
    if (appDown || !status) return 'hidden';
    if (status.state === 'active') return 'active';
    if (status.state === 'missed' && showMissed && status.missed_until && Date.parse(status.missed_until) > now) return 'missed';
    return 'hidden';
  }

  function normalizedCodes(codes) {
    return codes.map(function (c) { return String(c).toUpperCase(); }).sort();
  }

  // Pure: same discount codes, whatever the case or order.
  function sameCodes(a, b) {
    return normalizedCodes(a).join(',') === normalizedCodes(b).join(',');
  }

  // Pure: the variant whose price is shown (form choice, then theme default, then first), or null.
  function pickVariant(variants, formVariantId, defaultVariantId) {
    variants = variants || {};
    var keys = Object.keys(variants);
    if (formVariantId != null && String(formVariantId) in variants) return String(formVariantId);
    if (defaultVariantId != null && String(defaultVariantId) in variants) return String(defaultVariantId);
    return keys.length ? keys[0] : null;
  }

  function promoKey(id, statuses) {
    var s = statuses[String(id)];
    return s ? id + ':' + s.state + ':' + s.discount_percent : id + ':-';
  }

  // Pure: what the server needs to know about a cart (token, promo products with their promo state, applied codes).
  function cartSignature(cart, statuses) {
    var ids = cart.items.map(function (i) { return String(i.product_id); })
      .filter(function (id, i, all) { return all.indexOf(id) === i; }).sort();
    var codes = normalizedCodes((cart.discount_codes || []).map(function (c) { return c.code; }));
    return [cart.token, ids.map(function (id) { return promoKey(id, statuses); }).join(','), codes.join(',')].join('|');
  }

  // Pure: a stored signature is only trusted for a minute.
  function signatureFresh(storedAtMs, nowMs) {
    return storedAtMs > 0 && nowMs - storedAtMs < 60000;
  }

  // Pure: did the promo of a cart product change between two status snapshots. A product unknown so far
  // (the first status fetch failed) counts as changed only when it now has a promo.
  function promoChanged(ids, before, after) {
    return ids.some(function (id) {
      return String(id) in before ? promoKey(id, before) !== promoKey(id, after) : !!after[String(id)];
    });
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  // Pure: the end of a promo in the visitor's local time, counted in calendar days (DST-safe).
  function endsLabel(endsAt, now) {
    function day(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime(); }
    var days = Math.round((day(endsAt) - day(now)) / 864e5);
    if (days <= 0) return { key: 'endsToday', vars: { time: pad(endsAt.getHours()) + ':' + pad(endsAt.getMinutes()) } };
    if (days === 1) return { key: 'endsTomorrow', vars: {} };
    return { key: 'endsInDays', vars: { days: days } };
  }

  var pure = {
    endsLabel: endsLabel, sameCodes: sameCodes, pickVariant: pickVariant, cartSignature: cartSignature, signatureFresh: signatureFresh, promoChanged: promoChanged,
    computeCaps: computeCaps, mergeCodes: mergeCodes, promoPriceCents: promoPriceCents,
    formatMoney: formatMoney, displayState: displayState
  };
  if (typeof module === 'object' && module.exports) {
    module.exports = pure;
    return;
  }

  var POLL_MS = 15000;
  var CART_MUTATION = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
  var SIGNATURE_KEY = 'flash-promo-sig';
  var SIGNATURE_AT_KEY = 'flash-promo-sig-at';
  var cartIds = [];
  var RELOAD_KEY = 'flash-promo-reload';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var TEXTS = Object.assign({
    badge: '-{percent}%',
    title: 'Flash Sales',
    banner: 'Flash Sales',
    remaining: 'only *{remaining} of {total} remaining*',
    remainingProduct: 'Only *{remaining} of {total} remaining* at promo price',
    ended: '*{remaining} of {total} remaining*',
    endsToday: 'Ends today {time}',
    endsTomorrow: 'Ends tomorrow',
    endsInDays: 'Ends in {days} days',
    capped: 'Maximum {allowed} unit(s) at the promo price.',
    syncFailed: 'The flash discount could not be applied. Please try again in a moment.',
    tooManyCodes: 'Too many discount codes in the cart: some of them do not apply.'
  }, root.FlashPromoTexts || {});
  var MONEY_FORMAT = root.FlashPromoMoneyFormat || '{{amount}}';
  var nativeFetch = root.fetch.bind(root);
  var statuses = {};
  var fetchedAt = 0;
  var appDown = false;
  var missedTimer = null;

  function t(key, vars) {
    return TEXTS[key].replace(/\{(\w+)\}/g, function (_, k) { return vars[k]; });
  }

  function elements() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-flash-promo]'));
  }

  function pageIds() {
    return elements().map(function (el) { return el.dataset.productId; });
  }

  function parse(json) {
    try { return json ? JSON.parse(json) : null; } catch (e) { return null; }
  }

  function statusFor(el) {
    var id = el.dataset.productId;
    return id in statuses ? statuses[id] : parse(el.dataset.initial);
  }

  function node(tag, cls, text) {
    var n = document.createElement(tag);
    n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function closest(el, selector) {
    try { return selector ? el.closest(selector) : null; } catch (e) { return null; } // invalid selector
  }

  // Hides the theme's own price and express-checkout buttons while our simulated price is shown.
  function toggleNative(el, hide) {
    var scope = closest(el, el.dataset.scope) || el.parentElement;
    if (!scope || !el.dataset.hide) return;
    var natives = [];
    try { natives = scope.querySelectorAll(el.dataset.hide); } catch (e) { return; }
    Array.prototype.forEach.call(natives, function (n) {
      if (n !== el && !el.contains(n)) n.classList.toggle('flash-promo-hidden', hide);
    });
  }

  function formVariantId(el) {
    var sel = 'form[action*="/cart/add"] [name="id"]';
    var scope = closest(el, el.dataset.scope);
    var input = (scope && scope.querySelector(sel)) || document.querySelector(sel);
    return input ? String(input.value) : null;
  }

  function sessionGet(key) {
    try { return root.sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function sessionSet(key, value) {
    try { root.sessionStorage.setItem(key, value); } catch (e) { /* storage unavailable */ }
  }

  // Price in cents of what the block stands for: the selected variant on a product page, the product on a card.
  function prices(el) {
    var variants = parse(el.dataset.variants);
    if (variants) {
      var key = pickVariant(variants, formVariantId(el), el.dataset.selectedVariant);
      var v = key && variants[key];
      return v ? { price: v.price, compare: v.compare || 0 } : null;
    }
    return el.dataset.price ? { price: Number(el.dataset.price), compare: Number(el.dataset.compare || 0) } : null;
  }

  // The counter, with the text between asterisks in bold.
  function counter(key, s, remaining) {
    var p = node('p', 'flash-promo__counter');
    t(key, { remaining: remaining, total: s.total }).split('*').forEach(function (text, i) {
      p.appendChild(i % 2 ? node('strong', '', text) : document.createTextNode(text));
    });
    return p;
  }

  // Keeps the room of a node whose content is not known yet: no layout shift when it arrives.
  function reserve(n, pending) {
    if (pending) n.classList.add('flash-promo__pending');
    return n;
  }

  function bar(remaining, total) {
    var b = node('div', 'flash-promo__bar');
    var fill = node('span', '');
    fill.style.width = (total > 0 ? Math.max(0, Math.min(100, (remaining / total) * 100)) : 0) + '%';
    b.appendChild(fill);
    return b;
  }

  function endsPill(s) {
    var endsAt = s.ends_at ? new Date(s.ends_at) : null; // a metafield written before ends_at existed: the first poll brings it
    if (!endsAt || isNaN(endsAt)) return null;
    var label = endsLabel(endsAt, new Date());
    return node('span', 'flash-promo__ends', t(label.key, label.vars));
  }

  function priceNodes(el, s) {
    var p = prices(el);
    if (!p) return [];
    return [
      node('span', 'flash-promo__price', formatMoney(promoPriceCents(p.price, s.discount_percent), MONEY_FORMAT)),
      node('s', 'flash-promo__compare', formatMoney(Math.max(p.price, p.compare), MONEY_FORMAT))
    ];
  }

  // What a block draws into `out`, by its part: "media" (overlays on the image), "meter" (badge, counter, bar),
  // "box" (product page box), "price", "discount" (badge alone), "banner" (repeated title strip);
  // "product" is box + price; a card without part draws meter + price.
  function draw(el, s, state, out) {
    var part = el.dataset.part || 'meter price';
    if (part === 'product') part = 'box price';
    var ended = state === 'missed';
    var pending = !ended && s.remaining == null; // the metafield has no counter: it comes with the first status poll
    var remaining = ended ? 0 : pending ? s.total || 0 : s.remaining;
    var add = function (n) { if (n) out.appendChild(n); };
    if (/\bbox\b/.test(part)) {
      var box = node('div', 'flash-promo__box');
      var head = node('div', 'flash-promo__head');
      head.appendChild(node('span', 'flash-promo__badge', t('badge', { percent: s.discount_percent })));
      head.appendChild(node('span', 'flash-promo__title', t('title', {})));
      var pill = endsPill(s);
      if (pill) head.appendChild(pill);
      box.appendChild(head);
      box.appendChild(reserve(counter('remainingProduct', s, remaining), pending));
      box.appendChild(reserve(bar(remaining, s.total), pending));
      add(box);
    }
    if (/\bmedia\b/.test(part)) {
      add(node('span', 'flash-promo__label', t('title', {})));
      if (!ended) add(endsPill(s));
    }
    if (/\bmeter\b/.test(part)) {
      var row = node('div', 'flash-promo__row');
      row.appendChild(node('span', 'flash-promo__badge', t('badge', { percent: s.discount_percent })));
      row.appendChild(reserve(counter(ended ? 'ended' : 'remaining', s, remaining), pending));
      add(row);
      add(reserve(bar(remaining, s.total), pending));
    }
    if (/\bdiscount\b/.test(part)) add(node('span', 'flash-promo__badge', t('badge', { percent: s.discount_percent })));
    if (/\bbanner\b/.test(part)) {
      var strip = node('div', 'flash-promo__banner');
      for (var i = 0; i < 20; i++) {
        var item = node('span', '', t('banner', {}));
        if (i) {
          var sep = node('span', '', '%'); // centred between two titles by the strip gap
          sep.setAttribute('aria-hidden', 'true');
          item.setAttribute('aria-hidden', 'true');
          strip.appendChild(sep);
        }
        strip.appendChild(item);
      }
      add(strip);
    }
    if (/\bprice\b/.test(part)) {
      var line = node('div', 'flash-promo__prices');
      priceNodes(el, s).forEach(function (n) { line.appendChild(n); });
      add(line);
    }
  }

  function render() {
    var now = Date.now();
    var nextExpiry = Infinity;
    elements().forEach(function (el) {
      var s = statusFor(el);
      var state = displayState(s, el.dataset.showMissed === 'true', now, appDown);
      var fadeTarget = closest(el, el.dataset.grayscaleTarget);
      var out = document.createElement('div');
      if (fadeTarget) fadeTarget.classList.toggle('flash-promo-ended', state === 'missed');
      toggleNative(el, state !== 'hidden');
      if (state !== 'hidden') draw(el, s, state, out);
      if (out.innerHTML !== el.innerHTML) { // polls redraw only what changed: no flicker every 15 s
        el.textContent = '';
        while (out.firstChild) el.appendChild(out.firstChild);
      }
      el.dataset.state = state; // lets theme CSS style around an active promo (borders)
      if (state === 'missed') nextExpiry = Math.min(nextExpiry, Date.parse(s.missed_until));
      el.hidden = state === 'hidden';
    });
    clearTimeout(missedTimer);
    if (nextExpiry !== Infinity) missedTimer = setTimeout(render, nextExpiry - now + 250);
  }

  function storeSignature(cart) {
    sessionSet(SIGNATURE_KEY, cartSignature(cart, statuses));
    sessionSet(SIGNATURE_AT_KEY, String(Date.now()));
  }

  function signatureStored(cart) {
    return signatureFresh(Number(sessionGet(SIGNATURE_AT_KEY) || 0), Date.now()) && sessionGet(SIGNATURE_KEY) === cartSignature(cart, statuses);
  }

  // fromEnforce: the running enforce() syncs with these statuses itself, so no second run is scheduled.
  function refresh(extraIds, fromEnforce) {
    var ids = (extraIds || []).map(String).concat(cartIds, pageIds()).filter(function (id, i, all) { return id && all.indexOf(id) === i; });
    if (!ids.length) return Promise.resolve(statuses);
    return nativeFetch('/apps/flash/status?ids=' + ids.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('status'); return r.json(); })
      .then(function (data) {
        var before = Object.assign({}, statuses);
        ids.forEach(function (id) { statuses[id] = data[id] || null; });
        if (!fromEnforce && promoChanged(cartIds, before, statuses)) setTimeout(function () { enforce(false); }, 0);
        fetchedAt = Date.now();
        appDown = false;
      })
      .catch(function () { appDown = true; })
      .then(function () {
        render();
        applyQuantityMax();
        return statuses;
      });
  }

  function statusOfVariant(variantId) {
    for (var pid in statuses) {
      var s = statuses[pid];
      if (s && s.variants && String(variantId) in s.variants) return s;
    }
    return null;
  }

  function cap(variantId, qty) {
    var s = statusOfVariant(variantId);
    if (!s || s.state !== 'active' || s.remaining <= 0) return qty;
    var stock = s.variants[String(variantId)];
    return Math.max(1, Math.min(qty, s.remaining, stock == null ? Infinity : stock));
  }

  function applyQuantityMax() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var id = form.querySelector('[name="id"]');
      var qty = form.querySelector('[name="quantity"]');
      if (!id || !qty) return;
      var s = statusOfVariant(id.value);
      if (!s || s.state !== 'active') { qty.removeAttribute('max'); return; }
      var max = cap(id.value, Infinity);
      qty.max = max;
      if (Number(qty.value) > max) qty.value = max;
    });
  }

  function toast(text) {
    var n = node('div', 'flash-promo-toast', text);
    document.body.appendChild(n);
    setTimeout(function () { n.remove(); }, 4000);
  }

  function readCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      cartIds = cart.items.map(function (i) { return String(i.product_id); });
      return cart;
    });
  }

  // Step 1: soft quantity cap. Resolves with the corrections applied and the cart (null when it changed).
  function capCart() {
    return readCart().then(function (cart) {
      var ids = cart.items.map(function (i) { return String(i.product_id); });
      if (!ids.length) return { fixes: [], cart: cart };
      var stale = Date.now() - fetchedAt > POLL_MS || ids.some(function (id) { return !(id in statuses); });
      return (stale ? refresh(ids, true) : Promise.resolve()).then(function () {
        var applied = [];
        return computeCaps(cart.items, statuses).reduce(function (chain, fix) {
          return chain.then(function () {
            // nativeFetch: our own calls never re-trigger the interception
            return nativeFetch('/cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: fix.key, quantity: fix.allowed }) })
              .then(function (r) { if (!r.ok) throw new Error('change'); applied.push(fix); })
              .catch(function () {});
          });
        }, Promise.resolve()).then(function () { return { fixes: applied, cart: applied.length ? null : cart }; });
      });
    });
  }

  // Step 2: make the cart's flash codes match its promo products. Resolves with true when the codes changed.
  function syncCodes(notify, knownCart) {
    return (knownCart ? Promise.resolve(knownCart) : readCart()).then(function (cart) {
      var current = (cart.discount_codes || []).map(function (c) { return c.code; });
      var ids = cart.items.map(function (i) { return i.product_id; }).filter(function (id, i, all) { return all.indexOf(id) === i; });
      var concerned = current.some(isFlashCode) || ids.some(function (id) { return statuses[String(id)]; });
      if (!concerned || signatureStored(cart)) return false;

      return nativeFetch('/apps/flash/cart', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ token: cart.token, product_ids: ids }) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (data) {
          var merged = mergeCodes(current, data.codes || []);
          if (merged.overflow && notify) toast(t('tooManyCodes', {}));
          if (sameCodes(merged.codes, current)) {
            storeSignature(cart);
            return false;
          }
          return nativeFetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ discount: merged.codes.join(',') }) })
            .then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); })
            .then(function (updated) {
              var list = Array.isArray(updated && updated.discount_codes) ? updated.discount_codes : null;
              var applied = list ? list.map(function (c) { return c.code; }) : null;
              storeSignature({ token: cart.token, items: cart.items, discount_codes: list || merged.codes.map(function (c) { return { code: c }; }) });
              return applied ? !sameCodes(applied, current) : true;
            });
        });
    }).catch(function () {
      if (notify) toast(t('syncFailed', {}));
      return false;
    });
  }

  // One reload at most every 10 s: a cart that cannot settle must not loop.
  function reloadAllowed() {
    var last = Number(sessionGet(RELOAD_KEY) || 0);
    if (Date.now() - last < 10000) return false;
    sessionSet(RELOAD_KEY, String(Date.now()));
    return true;
  }

  var enforcing = null;
  var pending = false;
  function enforce(notify) {
    if (enforcing) { pending = true; return enforcing; } // a mutation landed mid-run: rerun once after
    enforcing = capCart()
      .catch(function () { return { fixes: [], cart: null }; })
      .then(function (step) {
        return syncCodes(notify, step.cart).then(function (codesChanged) {
          var fixes = step.fixes;
          if (!fixes.length && !codesChanged) return;
          var event = new CustomEvent('flash-promo:cart-updated', { detail: { capped: fixes, codesChanged: codesChanged }, cancelable: true });
          if (document.dispatchEvent(event)) { // nobody called preventDefault(): fallback
            if (/\/cart\/?$/.test(location.pathname)) {
              if (reloadAllowed()) location.reload();
            } else if (fixes.length) {
              toast(t('capped', fixes[0]));
            }
          }
        });
      })
      .catch(function () {})
      .then(function () {
        enforcing = null;
        if (pending) { pending = false; return enforce(true); }
      });
    return enforcing;
  }

  // Safety net: catch every cart mutation made by the theme or other apps.
  root.fetch = function (input, init) {
    var url = String((input && input.url) || input || '');
    var request = nativeFetch(input, init);
    if (CART_MUTATION.test(url)) request.then(function () { enforce(true); }, function () {});
    return request;
  };
  var open = XMLHttpRequest.prototype.open;
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._flashPromoUrl = String(url);
    return open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (CART_MUTATION.test(this._flashPromoUrl || '')) this.addEventListener('loadend', function () { enforce(true); });
    return send.apply(this, arguments);
  };

  root.FlashPromo = Object.assign({ cap: cap, refresh: refresh }, pure);

  function init() {
    render();
    refresh().then(function () { enforce(false); });
    document.addEventListener('change', function () {
      setTimeout(function () { render(); applyQuantityMax(); }, 0); // after the theme updated its form
    });
    setInterval(function () { if (!document.hidden) refresh(); }, POLL_MS);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
    var known = pageIds().join(',');
    new MutationObserver(function () {
      var ids = pageIds().join(',');
      if (ids !== known) { known = ids; render(); refresh(); }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(typeof window !== 'undefined' ? window : globalThis);
